import React, { useContext, useState } from 'react';
import { CartContext } from '../context/CartContext';
import { useUser } from '../context/UserContext';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '../Pages/Footer';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../config/api';

export default function Cart() {
  const { cart, dispatch } = useContext(CartContext);
  const { user} = useUser();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [promoCode, setPromoCode] = useState('');
const [discountAmount, setDiscountAmount] = useState(0);

  const [altAddress, setAltAddress] = useState('');
  const [altVille, setAltVille] = useState('');
  const [showAltForm, setShowAltForm] = useState(false);


const MAX_CART_ITEMS = 50;

// Toast si le panier dépasse la limite
if (cart.length > MAX_CART_ITEMS) {
  toast.error(`⚠️ Votre panier contient plus de ${MAX_CART_ITEMS} articles. Seuls les ${MAX_CART_ITEMS} premiers seront affichés.`);
}

// Limiter le nombre d'articles affichés
const displayedCart = cart.slice(0, MAX_CART_ITEMS);

const totalAmount = displayedCart.reduce(
  (acc, item) => acc + item.price * item.quantity,
  0
);

const finalAmount = Math.max(totalAmount - discountAmount, 0);

  // console.log("user depuis UserContext:", user);

  // Envoie la commande au backend puis ouvre la modale paiement
// const handlePayment = async () => {
//   setShowConfirmModal(false);

//   // Vérification user et token
//   if (!user || !user._id || !user.token) {
//     toast.error("Veuillez vous reconnecter avant de passer la commande.");
//     return;
//   }

//   if (!user.name || !user.address || !user.ville || !user.number || cart.length === 0) {
//     toast.error("Informations incomplètes ou panier vide.");
//     return;
//   }

//   const useAlt = showAltForm && (altAddress.trim() || altVille.trim());
//   const addressToUse = useAlt ? altAddress.trim() || user.address : user.address;
//   const villeToUse = useAlt ? altVille.trim() || user.ville : user.ville;

//   // const preparedCart = cart.map(p => ({
//   //   productId: p._id || p.id,
//   //   quantity: p.quantity,
//   //   title: p.title,
//   //   price: p.price,
//   //   img: p.img,
//   //   stockInsuffisant: p.stock === 0 || p.quantity > p.stock
//   // }));
//   const preparedDisplayedCart = displayedCart.map(p => ({
//   productId: p._id || p.id,
//   quantity: p.quantity,
//   title: p.title,
//   price: p.price,
//   img: p.img,
//   stockInsuffisant: p.stock === 0 || p.quantity > p.stock
// }));

//   const payload = {
//     name: `${user.name} ${user.surname || ''}`.trim(),
//     address: addressToUse,
//     ville: villeToUse,
//     number: user.number,
//     email: user.email,
//     cart: preparedDisplayedCart,
//     totalAmount: finalAmount,
//     promoCode: promoCode.trim() || null,
//     discountAmount,
//     adminId: user.adminId || user._id,
//     client: user._id,
//     livraisonAlt: useAlt ? { address: altAddress.trim(), ville: altVille.trim() } : undefined
//   };

//   try {
//     setLoading(true);

//     // Axios sécurisé avec token
//     const res = await axios.post(
//       `${API_URL}/commandes`,
//       payload,
//       {
//         headers: {
//           Authorization: `Bearer ${user.token}`,
//           'Content-Type': 'application/json'
//         }
//       }
//     );

//     toast.success("Panier validé !");
//     setShowPaymentModal(true);

//     // Optionnel : vider le panier après commande
//     // dispatch({ type: "CLEAR_CART" });

//   } catch (err) {
//     console.error("Erreur lors de la commande :", err.response?.data || err.message);
//     const message = err.response?.data?.message || "Une erreur est survenue lors de la commande.";
//     toast.error(message);
//   } finally {
//     setLoading(false);
//   }
// };

const handlePayment = async () => {
  setShowConfirmModal(false);

  // 🔐 Session expirée ou inexistante
  if (!user || !user._id || !user.token) {
    toast.error("🔐 Votre session a expiré. Veuillez vous reconnecter pour continuer.");
    return;
  }

  if (!user.name || !user.address || !user.ville || !user.number || cart.length === 0) {
    toast.error("Informations incomplètes ou panier vide.");
    return;
  }

  const useAlt = showAltForm && (altAddress.trim() || altVille.trim());
  const addressToUse = useAlt ? altAddress.trim() || user.address : user.address;
  const villeToUse = useAlt ? altVille.trim() || user.ville : user.ville;

  const preparedDisplayedCart = displayedCart.map(p => ({
    productId: p._id || p.id,
    quantity: p.quantity,
    title: p.title,
    price: p.price,
    img: p.img,
    stockInsuffisant: p.stock === 0 || p.quantity > p.stock
  }));

  const payload = {
    name: `${user.name} ${user.surname || ''}`.trim(),
    address: addressToUse,
    ville: villeToUse,
    number: user.number,
    email: user.email,
    cart: preparedDisplayedCart,
    totalAmount: finalAmount,
    promoCode: promoCode.trim() || null,
    discountAmount,
    adminId: user.adminId || user._id,
    client: user._id,
    livraisonAlt: useAlt
      ? { address: altAddress.trim(), ville: altVille.trim() }
      : undefined
  };

  try {
    setLoading(true);

    const res = await axios.post(
      `${API_URL}/commandes`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json"
        }
      }
    );

    toast.success("Panier validé !");
    setShowPaymentModal(true);

  } catch (err) {
    console.error("Erreur lors de la commande :", err.response?.data || err.message);

    // 🔐 Token expiré côté backend
    if (err.response?.status === 401) {
      toast.error("🔐 Votre session a expiré. Veuillez vous reconnecter pour continuer.");
      return;
    }

    const message =
      err.response?.data?.message ||
      "Une erreur est survenue lors de la commande.";

    toast.error(message);

  } finally {
    setLoading(false);
  }
};

  // Redirection vers Wave avec le montant dans l’URL
  const redirectToWave = () => {
    const waveUrl = `https://pay.wave.com/m/M_arcTk76nTDqc/c/ci/?amount=${finalAmount}`;
    window.location.href = waveUrl;
  };

const applyPromoCode = async () => {
  // Si champ vide, réinitialiser discount et retourner
  if (!promoCode.trim()) {
    setDiscountAmount(0);
    toast("Code promo effacé, réduction supprimée.");
    return;
  }

  try {
    setLoading(true);

    // Requête pour récupérer le code promo
    const res = await axios.get(`${API_URL}/promos?code=${promoCode.trim().toUpperCase()}`);
    const promo = res.data[0];

    if (!promo) {
      setDiscountAmount(0);
      return toast.error("Code promo invalide");
    }

    const now = new Date();

    // Vérification date d'expiration
    if (new Date(promo.expiresAt) < now) {
      setDiscountAmount(0);
      return toast.error("Ce code promo est expiré");
    }

    // Vérification si l'utilisateur a déjà utilisé ce code
    if (promo.usedBy && promo.usedBy.includes(user._id)) {
      setDiscountAmount(0);
      return toast.error("Vous avez déjà utilisé ce code promo");
    }

    // Vérification montant minimum
    if (promo.minAmount && totalAmount < promo.minAmount) {
      setDiscountAmount(0);
      return toast.error(`Montant minimum pour ce code : ${promo.minAmount.toLocaleString()} FCFA`);
    }

    // Calcul réduction
    let discount = 0;
    if (promo.type === "percentage") {
      discount = Math.floor(totalAmount * (promo.value / 100));
    } else {
      discount = promo.value;
    }

    setDiscountAmount(discount);
    toast.success(`Code promo appliqué : -${discount.toLocaleString()} FCFA`);

  } catch (err) {
    console.error(err);
    setDiscountAmount(0);
    toast.error("Erreur lors de l’application du code promo");
  } finally {
    setLoading(false);
  }
};



  return (
    <>
      <div className="container">
        {/* Fil d’Ariane */}
        <nav aria-label="breadcrumb" className="breadcrumb-container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">Accueil</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Panier</li>
          </ol>
        </nav>

        <h2 className="page-title">Votre panier</h2>

        <div className="main-orders">
          <div className="orders-container">
            {/* Colonne gauche : articles */}
            <div className="orders-left">
              {cart.length === 0 ? (
                <p className="empty-cart-msg"><i className="fa-solid fa-box"></i> Votre panier est vide.</p>
              ) : (
                displayedCart.map(item => (
                  <div key={item._id} className="cart-article">
                    {/* Quantité */}
                    <div className="quantity-control">
                      <button className="qty-btn"
                        onClick={() => dispatch({ type: 'REMOVE_FROM_CART', payload: item._id })}>
                        −
                      </button>
                      <div className="qty-display">{item.quantity}</div>
                      <button className="qty-btn"
                        onClick={() => dispatch({ type: 'ADD_TO_CART', payload: item })}>
                        +
                      </button>
                    </div>

                    {/* Infos produit */}
                    <div className="article-info">
                      <img
                        src={
                          item.img?.startsWith('http')
                            ? item.img
                            : `${API_URL}/uploads/${item.img}`
                        }
                        alt={item.title}
                        className="article-img"
                      />

                      <div className="article-texts">
                        <p className="article-title">{item.title}</p>
                        {/* <p className="article-category">{item.reference}</p> */}
                        <p className="article-qty">{item.quantity} unité(s)</p>
                        <p className="article-price">
                          {item.price.toLocaleString()} FCFA&nbsp;×&nbsp;{item.quantity}
                        </p>
                        {item.stock === 0 && (
                          <p className="stock-warning">⚠️ Rupture de stock</p>
                        )}
                      </div>
                    </div>

                    {/* Suppression */}
                    <button className="remove-article-btn"
                      title="Retirer"
                      onClick={() => dispatch({ type: 'REMOVE_FROM_CART', payload: item._id })}>
                      <i className="fa-solid fa-trash" />
                    </button>
                  </div>
                ))
              )}

              {/* {cart.length > 0 && (
                <button className="clear-cart-btn"
                  onClick={() => dispatch({ type: 'CLEAR_CART' })}>
                  Vider le panier
                </button>
              )} */}
            </div>

            {/* Colonne droite : résumé */}
            <div className="orders-right">
              <h6 className="summary-header">Résumé du panier</h6>

              <div className="summary-body">
                {/* Total */}
                <div className="total-container">
                  <h5>Total</h5>
                 <p className="total-price">{(totalAmount - discountAmount).toLocaleString()} FCFA</p>
                </div>

                {/* Coordonnées + destination */}
                <div className="user-info">
                  <h4>Coordonnées</h4>
                  {user ? (
                    <>
                      <p><strong>Nom :</strong> {user.name} {user.surname}</p>
                      <p><strong>Téléphone :</strong> {user.number}</p>
                      <p><strong>Email :</strong> {user.email}</p>
                      <p><strong>Adresse :</strong> {user.address}</p>
                      <p><strong>Ville :</strong> {user.ville}</p>

                      {/* Bouton destination alternative */}
                      <button
                        type="button"
                        className="alt-btn"
                        onClick={() => setShowAltForm(s => !s)} >
                        {showAltForm
                          ? 'Annuler la nouvelle destination'
                          : 'Ajouter une autre destination'}
                      </button>

                      {showAltForm && (
                        <div className="alt-form">
                          <input
                            type="text"
                            placeholder="Nouvelle adresse"
                            value={altAddress}
                            onChange={e => setAltAddress(e.target.value)}
                          />
                          <input
                            type="text"
                            placeholder="Ville"
                            value={altVille}
                            onChange={e => setAltVille(e.target.value)}
                          />
                        </div>
                      )}

                      <div className="promo-section">
                      <h5>Code Promo</h5>
                      <div className="promo-input">
                        <input
                          type="text"
                          placeholder="Entrez votre code promo"
                          value={promoCode}
                          onChange={e => setPromoCode(e.target.value)}
                        />
                        <button className="apply-btn" onClick={applyPromoCode}>
                          Appliquer
                        </button>
                      </div>
                      {discountAmount > 0 && (
                        <p className="promo-success">Réduction appliquée : {discountAmount.toLocaleString()} FCFA</p>
                      )}
                    </div>

                      {/* <div className='payment--box'>
                        <div className='payment--box--card'>
                          <img src="IMG_8837.jpg" alt="" />
                          <div className='payment--box--card--desc'>
                            <p>Veuillez nous parvenir la capture de votre paiement sur ce numéro whatsapp +225 07 49 69 88 48</p>
                          </div>
                        </div>
                      </div> */}
                    </>
                  ) : (
                    <p>Utilisateur non connecté</p>
                  )}
                </div>

                {/* Bouton validation */}
                <button
                  className="confirm-btn"
                  onClick={() => setShowConfirmModal(true)}
                  disabled={loading}>
                  {loading ? 'Traitement...' : 'Confirmer la commande'}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal confirmation avant envoi */}
        {showConfirmModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>Confirmer la commande</h2>
              <p>Êtes-vous sûr de vouloir valider la commande ?</p>

              <div className="modal-actions">
                <button className="btn-cancel" onClick={() => setShowConfirmModal(false)}>
                  Annuler
                </button>
                <button className="btn-confirm" onClick={handlePayment} disabled={loading}>
                  {loading ? 'Traitement...' : 'Effectuer le paiement'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal paiement avec QR code */}
        {showPaymentModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>Effectuez votre paiement</h2>
              <p>Montant à payer : <strong>{finalAmount.toLocaleString()} FCFA</strong></p>

              {/* QR code Wave */}
              {/* <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://pay.wave.com/m/M_arcTk76nTDqc/c/ci/?amount=${totalAmount}`}
                alt="QR Code paiement Wave"
                style={{ margin: '20px auto', display: 'block' }}
              /> */}
               <img src="IMG_8837.jpg" alt="" />
                <div className='payment--box--card--desc'>
                  <p>Veuillez nous parvenir la capture de votre paiement sur ce numéro whatsapp <br/>+225 01 01 88 59 81</p>
                 </div>

              <div className="modal-actions">
                <button className="btn-cancel" onClick={() => setShowPaymentModal(false)}>
                  Annuler
                </button>
                <button className="btn-confirm" onClick={() => {
                  setShowPaymentModal(false);
                  redirectToWave();
                }}>
                  Aller au paiement Wave (App)
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <Footer />
        <a
        href="https://wa.me/2250101885981?text=Bonjour,%20je%20souhaite%20des%20infos%20sur%20vos%20produits"
        target="_blank" rel="noreferrer" className="whatsapp-btn">
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Styles CSS */}
        <style>{`
        /* Container */
        .container {
          max-width: 1140px;
          margin: 30px auto 60px;
          padding: 0 20px;
          font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #2c3e50;
        }

        /* Breadcrumb */
        .breadcrumb-container {
          margin-bottom: 20px;
        }
        .breadcrumb {
          background: none;
          padding: 0;
          margin: 0;
          display: flex;
          gap: 10px;
          font-size: 0.9rem;
          color: gainsboro;
        }
        .breadcrumb a {
          color: #3498db;
          text-decoration: none;
          font-weight: 600;
        }
        .breadcrumb .active {
          color: #95a5a6;
          font-weight: 600;
          cursor: default;
        }

        /* Page Title */
        .page-title {
          font-size: 2.4rem;
          font-weight: 700;
          margin-bottom: 30px;
          color: #34495e;
          user-select: none;
        }

        /* Main flex container */
        .main-orders {
          display: flex;
          flex-direction: column;
          gap: 30px;
        }
        @media(min-width: 900px) {
          .main-orders {
            flex-direction: row;
            align-items: flex-start;
          }
        }

        /* Orders Container */
        .orders-container {
          display: flex;
          flex: 1;
          gap: 40px;
        }

        /* Left - Cart Items */
        .orders-left {
          flex: 1.7;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 25px rgb(0 0 0 / 0.08);
          padding: 30px;
          display: flex;
          flex-direction: column;
          gap: 20px;
          min-height: 400px;
        }
        .empty-cart-msg {
          font-size: 1.2rem;
          text-align: center;
          color: #7f8c8d;
          user-select: none;
        }

        .cart-article {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 15px 20px;
          border-radius: 12px;
          background: #f9fafb;
          box-shadow: 0 2px 10px rgb(0 0 0 / 0.04);
          transition: background-color 0.2s ease;
          user-select: none;
          position: relative;
        }
        .cart-article:hover {
          background: #e1f5e4;
        }

        /* Quantity control */
        .quantity-control {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #ecf0f1;
          border-radius: 10px;
          padding: 5px 8px;
          width: 50px;
          user-select: none;
          box-shadow: inset 0 1px 2px rgb(255 255 255 / 0.7);
        }
        .qty-btn {
          background: #3498db;
          border: none;
          color: white;
          font-weight: 700;
          font-size: 1.2rem;
          line-height: 1;
          width: 100%;
          height: 28px;
          cursor: pointer;
          border-radius: 6px;
          transition: background-color 0.3s ease;
          user-select: none;
        }
        .qty-btn:hover:not(:disabled) {
          background-color: #2980b9;
        }
        .qty-display {
          font-weight: 700;
          font-size: 1.1rem;
          margin: 5px 0;
          user-select: none;
        }

        /* Article info */
        .article-info {
          display: flex;
          gap: 20px;
          flex: 1;
          align-items: center;
        }
        .article-img {
          width: 100px;
          height: 90px;
          object-fit: contain;
          border-radius: 8px;
          background-color: #f5f7fa;
          box-shadow: 0 1px 5px rgb(0 0 0 / 0.1);
          user-select: none;
        }
        .article-texts {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .article-title {
          font-weight: 700;
          font-size: 1.1rem;
          color: #2c3e50;
        }
        .article-category, .article-qty, .article-price {
          color: #7f8c8d;
          font-size: 0.9rem;
        }
        .stock-warning {
          color: #e74c3c;
          font-weight: 600;
          font-size: 0.9rem;
          user-select: none;
        }

        /* Remove button */
        .remove-article-btn {
          background: none;
          border: none;
          color: #e74c3c;
          cursor: pointer;
          font-size: 1.3rem;
          transition: color 0.3s ease;
          user-select: none;
          padding: 5px;
          border-radius: 6px;
        }
        .remove-article-btn:hover {
          color: #c0392b;
        }

        /* Clear cart button */
        .clear-cart-btn {
          margin-top: auto;
          background: #e74c3c;
          color: white;
          border: none;
          border-radius: 30px;
          padding: 12px 25px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          box-shadow: 0 5px 15px rgb(231 76 60 / 0.6);
          transition: background-color 0.3s ease;
          user-select: none;
        }
        .clear-cart-btn:hover {
          background: #c0392b;
        }

        /* Right - Summary */
        .orders-right {
          flex: 1;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 8px 25px rgb(0 0 0 / 0.08);
          padding: 30px;
          display: flex;
          flex-direction: column;
          gap: 25px;
          min-height: 400px;
        }
        .summary-header {
          font-weight: 700;
          font-size: 1.3rem;
          color: #34495e;
          border-bottom: 2px solid#4b00cc;
          padding-bottom: 10px;
          user-select: none;
        }
        .summary-body {
          display: flex;
          flex-direction: column;
          gap: 25px;
        }
        .total-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 700;
          font-size: 1.4rem;
          color: #4b00cc;
          user-select: none;
        }
        .total-price {
          font-weight: 900;
          font-size: 1.6rem;
        }

        /* User info */
        .user-info h4 {
          font-weight: 700;
          font-size: 1.2rem;
          color: #34495e;
          user-select: none;
        }
        .user-info p {
          margin: 3px 0;
          font-size: 1rem;
          color: #5d6d7e;
          user-select: text;
        }

        /* Confirm button */
        .confirm-btn {
          background: #4b00cc;
          color: white;
          border: none;
          border-radius: 30px;
          padding: 15px 0;
          font-weight: 700;
          font-size: 1.2rem;
          cursor: pointer;
          box-shadow: 0 8px 20px rgb(39 5 199 / 0.5);
          transition: background-color 0.3s ease;
          user-select: none;
        }
        .confirm-btn:hover:not(:disabled) {
          background: #35009a;
        }
        .confirm-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* Modal Overlay */
        .modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background-color: rgba(0,0,0,0.45);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          padding: 15px;
        }

        /* Modal Content */
        .modal-content {
          background: white;
          padding: 30px 40px;
          border-radius: 20px;
          max-width: 400px;
          width: 100%;
          box-shadow: 0 10px 30px rgb(0 0 0 / 0.25);
          text-align: center;
          user-select: none;
        }
        .modal-content h2 {
          font-weight: 900;
          font-size: 1.7rem;
          margin-bottom: 20px;
          color: #4b00cc;
        }
        .modal-content p {
          font-size: 1.1rem;
          margin-bottom: 30px;
          color: #34495e;
        }

        /* Modal Buttons */
        .modal-actions {
          display: flex;
          justify-content: center;
          gap: 15px;
        }
        .btn-cancel, .btn-confirm {
          flex: 1;
          padding: 12px 0;
          font-weight: 700;
          font-size: 1.1rem;
          border-radius: 30px;
          cursor: pointer;
          border: none;
          user-select: none;
          transition: background-color 0.3s ease;
        }
        .btn-cancel {
          background: #e74c3c;
          color: white;
          box-shadow: 0 5px 15px rgb(231 76 60 / 0.5);
        }
        .btn-cancel:hover {
          background: #c0392b;
        }
        .btn-confirm {
          background: #4b00cc;
          color: white;
          box-shadow: 0 5px 15px rgb(75 0 204 / 0.5);
        }
        .btn-confirm:hover:not(:disabled) {
          background: #35009a;
        }
        .btn-confirm:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* Input fields alt address */
        .alt-form input {
          width: 100%;
          padding: 10px 12px;
          margin-bottom: 10px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 1rem;
        }

        /* Alt destination button */
        .alt-btn {
          margin-top: 10px;
          background: #3498db;
          border: none;
          padding: 10px 18px;
          color: white;
          border-radius: 20px;
          font-weight: 700;
          cursor: pointer;
          user-select: none;
          box-shadow: 0 5px 15px rgb(52 152 219 / 0.5);
          transition: background-color 0.3s ease;
        }
        .alt-btn:hover {
          background: #2980b9;
        }
          .promo-section {
  margin-top: 20px;
}
.promo-input {
  display: flex;
  gap: 10px;
}
.promo-input input {
  flex: 1;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
}
.apply-btn {
  background: #4b00cc;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
}
.apply-btn:hover {
  background: #35009a;
}
.promo-success {
  margin-top: 8px;
  color: #27ae60;
  font-weight: 600;
}
      `}</style>
    </>
  );
}